require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./seren-row-penthouses-forbes.json") })
        }
      }, "path---seren-row-penthouses-forbes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---seren-row-penthouses-forbes!./.cache/json/seren-row-penthouses-forbes.json
// module id = 891
// module chunks = 231608221292675